import gql from "graphql-tag";
import { partsStoreDetailsFields } from "./getPartsStore";

export const partOrderItemDetailsFields = `
  id
  name
  partNumber
  units
  vendorUnitCost
  status
  createdAt
  updatedAt
`;

export const cancelationDetailsFields = `
  method
  responsible
  representativeSpokenTo
  notes
  timeStamp
  actor
`;

export const partOrderDetailsFields = `
  id
  orderNumber
  notes
  orderTotalCost
  status
  createdAt
  createdBy
  timestamp
  updatedAt
  orderMethod
  partOrderingIssue
  cancelationDetails {
    ${cancelationDetailsFields}
  }
  store {
    ${partsStoreDetailsFields}
  }
  job {
    id
    jobNumber
  }
  items {
    ${partOrderItemDetailsFields}
  }
`;

export const GET_PART_ORDERS = gql`
  query getPartOrders($filter: JSON) {
    getPartOrders(filter: $filter) {
      data {
        ${partOrderDetailsFields}
      }
      total
    }
  }
`;
